<div class="container-fluid p-4">
  <mat-card>
    <mat-card-header class="d-flex justify-content-between align-items-center">
      <mat-card-title>Education Sessions Report (Children Above 14 Years)</mat-card-title>
      <button *ngIf="!hideFilters"
              mat-stroked-button
              (click)="showFilters = !showFilters"
              style="margin-left: auto;">
        <mat-icon>{{ showFilters ? 'expand_less' : 'expand_more' }}</mat-icon>
        {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
      </button>
    </mat-card-header>

    <mat-card-content>
      <!-- Filters Section - Only show when not embedded and showFilters is true -->
      <div *ngIf="!hideFilters && showFilters">
        <div class="row mb-3">
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Financial Year</mat-label>
              <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange()">
                <mat-option [value]="2024">2024-2025</mat-option>
                <mat-option [value]="2025">2025-2026</mat-option>
                <mat-option [value]="2026">2026-2027</mat-option>
                <mat-option [value]="2027">2027-2028</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Quarter</mat-label>
              <mat-select [(ngModel)]="selectedQuarter" (selectionChange)="onQuarterChange()">
                <mat-option *ngFor="let quarter of quarters" [value]="quarter.value">
                  {{ quarter.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Centre</mat-label>
              <mat-select [(ngModel)]="selectedCentre">
                <mat-option value="All">All Centres</mat-option>
                <mat-option *ngFor="let centre of centres" [value]="centre.centreCode">
                  {{ centre.centreName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Date Range</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
                <input matEndDate [(ngModel)]="endDate" placeholder="End date">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="row mb-3">
          <div class="col-12 d-flex gap-2">
            <button mat-raised-button color="primary" (click)="search()">
              <mat-icon>search</mat-icon>
              Search
            </button>
            <button mat-raised-button color="accent" (click)="exportToExcel()" [disabled]="centreReports.length === 0">
              <mat-icon>download</mat-icon>
              Export to Excel
            </button>
            <button mat-raised-button (click)="clear()">
              <mat-icon>clear</mat-icon>
              Clear
            </button>
          </div>
        </div>
      </div>

      <!-- Results Table -->
      <div class="table-responsive" *ngIf="centreReports.length > 0">
        <table mat-table [dataSource]="centreReports" class="w-100 mat-elevation-z2">
          <!-- Centre Name Column -->
          <ng-container matColumnDef="centreName">
            <th mat-header-cell *matHeaderCellDef class="fw-bold">Centre Name</th>
            <td mat-cell *matCellDef="let report">{{ report.centreName }}</td>
            <td mat-footer-cell *matFooterCellDef class="fw-bold">Total</td>
          </ng-container>

          <!-- Individual Sessions Column -->
          <ng-container matColumnDef="individualSessions">
            <th mat-header-cell *matHeaderCellDef class="fw-bold">Total Individual Sessions</th>
            <td mat-cell *matCellDef="let report">{{ report.individualSessions }}</td>
            <td mat-footer-cell *matFooterCellDef class="fw-bold">
              {{ getTotalIndividualSessions() }}
            </td>
          </ng-container>

          <!-- Children Above 14 (Individual) Column -->
          <ng-container matColumnDef="childrenAbove14Individual">
            <th mat-header-cell *matHeaderCellDef class="fw-bold">Children 14+ Sessions </th>
            <td mat-cell *matCellDef="let report">{{ report.childrenAbove14Individual }}</td>
            <td mat-footer-cell *matFooterCellDef class="fw-bold">
              {{ getTotalChildrenAbove14Individual() }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>

      <!-- No Data Message -->
      <div *ngIf="centreReports.length === 0" class="text-center py-5">
        <mat-icon class="text-muted" style="font-size: 48px; width: 48px; height: 48px;">info</mat-icon>
        <p class="text-muted mt-2">No data available. Please select filters and click Search.</p>
      </div>
    </mat-card-content>
  </mat-card>
</div>

